import { render, staticRenderFns } from "./corneaMap.vue?vue&type=template&id=34f41f6b&scoped=true&"
import script from "./corneaMap.vue?vue&type=script&lang=js&"
export * from "./corneaMap.vue?vue&type=script&lang=js&"
import style0 from "./corneaMap.vue?vue&type=style&index=0&id=34f41f6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f41f6b",
  null
  
)

export default component.exports